import React from 'react'

import useSvgId from '../../hooks/useSvgId'

// viewBox is offset by 4 so the flag circle (5–27) lines up with BaIcon's (1–23)
const EngIcon = ({ active, size = 24 }) => {
  const clipId = useSvgId('eng-icon-clip')

  return (
    <svg width={size} height={size} viewBox="4 4 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath={`url(#${clipId})`}>
        <path d="M6 6H26V26H6V6Z" fill="#012169" />
        <path
          d="M26 6V8.5L18.5781 16L26 23.3047V26H23.3828L15.9219 18.6562L8.65625 26H6V23.3438L13.2656 16.0391L6 8.89062V6H8.42188L15.9219 13.3438L23.1875 6H26Z"
          fill="#EFFBE4"
        />
        <path
          d="M13.1875 18.6562L13.6172 19.9844L7.64062 26H6V25.8828L13.1875 18.6562ZM18.0312 18.1875L20.1406 18.5L26 24.2422V26L18.0312 18.1875ZM26 6L18.5 13.6562L18.3438 11.9375L24.2031 6H26ZM6 6.03906L13.5391 13.4219L11.2344 13.1094L6 7.91406V6.03906Z"
          fill="#C8102E"
        />
        <path d="M12.875 6V26H19.125V6H12.875ZM6 12.875V19.125H26V12.875H6Z" fill="#EFFBE4" />
        <path d="M6 14.125V17.875H26V14.125H6ZM14.125 6V26H17.875V6H14.125Z" fill="#C8102E" />
      </g>
      <rect
        x="5"
        y="5"
        width="22"
        height="22"
        rx="11"
        stroke={`${active ? 'white' : '#006EAB'}`}
        strokeWidth="2"
        shapeRendering="crispEdges"
      />
      <defs>
        <clipPath id={clipId}>
          <rect x="6" y="6" width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default EngIcon
